export default __webpack_public_path__ + "static/media/cubbies2.e00cc2e4.svg";